(function(window,document){
  'use strict';

  var CURRENCY='MAD';
  var EVENT_VERSION='1.0';
  var ATTRIBUTION_KEY='lumaTrackingAttributionV1';
  var PURCHASE_KEY='lumaTrackedPurchaseIdsV1';
  var CHECKOUT_KEY='lumaTrackedCheckoutKeysV1';

  window.dataLayer=window.dataLayer||[];

  function roundMoney(value){
    var number=Number(value||0);
    return Number.isFinite(number)?Math.round(number*100)/100:0;
  }

  function readJson(storage,key,fallback){
    try{
      var raw=storage.getItem(key);
      return raw?JSON.parse(raw):fallback;
    }catch(_error){
      return fallback;
    }
  }

  function writeJson(storage,key,value){
    try{storage.setItem(key,JSON.stringify(value));}catch(_error){}
  }

  function captureAttribution(){
    var existing=readJson(sessionStorage,ATTRIBUTION_KEY,null);
    if(existing)return existing;

    var params=new URLSearchParams(window.location.search);
    var keys=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','ttclid'];
    var attribution={landing_path:window.location.pathname};
    keys.forEach(function(key){
      var value=params.get(key);
      if(value)attribution[key]=String(value).slice(0,500);
    });
    writeJson(sessionStorage,ATTRIBUTION_KEY,attribution);
    return attribution;
  }

  var attribution=captureAttribution();

  function normalizeItem(product,price){
    product=product||{};
    return {
      item_id:String(product.id||''),
      item_name:String(product.title||''),
      item_variant:String(product.variantId||''),
      price:roundMoney(price!=null?price:product.price),
      quantity:1
    };
  }

  function validOffer(offer){
    return Boolean(offer&&Number(offer.count)>0&&Number(offer.price)>0);
  }

  function offerUnitPrice(offer){
    return validOffer(offer)?roundMoney(Number(offer.price)/Number(offer.count)):0;
  }

  function offerItems(selected,offer){
    var unitPrice=offerUnitPrice(offer);
    return (Array.isArray(selected)?selected:[]).map(function(product){
      return normalizeItem(product,unitPrice);
    });
  }

  function pushBusinessEvent(eventName,ecommerce,extra){
    try{
      window.dataLayer.push({ecommerce:null});
      var eventPayload={
        event:eventName,
        luma_event_version:EVENT_VERSION,
        ecommerce:ecommerce,
        luma_attribution:attribution
      };
      if(extra&&extra.tiktokEventId){
        eventPayload.luma_tiktok_event_id=String(extra.tiktokEventId);
      }
      window.dataLayer.push(eventPayload);
      return true;
    }catch(error){
      console.warn('LUMA tracking dataLayer push failed',error);
      return false;
    }
  }

  function viewItem(product){
    if(!product||!product.id)return false;
    var item=normalizeItem(product,product.price);
    return pushBusinessEvent('luma_view_item',{
      currency:CURRENCY,
      value:roundMoney(item.price),
      items:[item]
    });
  }

  function addToCart(product,offer){
    if(!product||!product.id||!validOffer(offer))return false;
    var item=normalizeItem(product,offerUnitPrice(offer));
    return pushBusinessEvent('luma_add_to_cart',{
      currency:CURRENCY,
      value:roundMoney(item.price),
      items:[item]
    });
  }

  function checkoutKey(selected,offer){
    return String(offer.count)+'|'+selected.map(function(item){return String(item.id||'');}).join('|');
  }

  function beginCheckout(selected,offer){
    selected=Array.isArray(selected)?selected:[];
    if(!validOffer(offer)||selected.length!==Number(offer.count))return false;

    var key=checkoutKey(selected,offer);
    var seen=readJson(sessionStorage,CHECKOUT_KEY,[]);
    if(Array.isArray(seen)&&seen.indexOf(key)!==-1)return false;

    var pushed=pushBusinessEvent('luma_begin_checkout',{
      currency:CURRENCY,
      value:roundMoney(offer.price),
      items:offerItems(selected,offer)
    });

    if(pushed){
      if(!Array.isArray(seen))seen=[];
      seen.push(key);
      writeJson(sessionStorage,CHECKOUT_KEY,seen.slice(-20));
    }
    return pushed;
  }

  function purchase(orderId,selected,offer){
    orderId=String(orderId||'').trim();
    selected=Array.isArray(selected)?selected:[];
    if(!orderId||!validOffer(offer)||selected.length!==Number(offer.count))return false;

    var seen=readJson(localStorage,PURCHASE_KEY,[]);
    if(Array.isArray(seen)&&seen.indexOf(orderId)!==-1)return false;

    var pushed=pushBusinessEvent('luma_purchase',{
      transaction_id:orderId,
      currency:CURRENCY,
      value:roundMoney(offer.price),
      items:offerItems(selected,offer)
    },{tiktokEventId:orderId});

    if(pushed){
      if(!Array.isArray(seen))seen=[];
      seen.push(orderId);
      writeJson(localStorage,PURCHASE_KEY,seen.slice(-50));
    }
    return pushed;
  }

  function initProductView(){
    var node=document.querySelector('[data-luma-product-view]');
    if(!node)return;
    try{
      var product=JSON.parse(node.textContent||'{}');
      viewItem(product);
    }catch(error){
      console.warn('LUMA product tracking data invalid',error);
    }
  }

  window.LumaTracking=Object.freeze({
    viewItem:viewItem,
    addToCart:addToCart,
    beginCheckout:beginCheckout,
    purchase:purchase
  });

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initProductView,{once:true});
  }else{
    initProductView();
  }
})(window,document);
